let platForms = window.projectImgUrl;
let skin = ''; 
if (platForms === 'amjs') {
    skin = '澳门金沙';
} else if (platForms === 'bmyl') {
    skin = '博美娱乐';
} else if (platForms === 'amxpj') {
    skin = '澳门新葡京';
} else if (platForms === 'qxyl') {
    skin = '千禧娱乐';
}
const zh = {
    'titilName': skin, //平台名
    'name': 'data',
    // 首页
    'homePage': {
        'login': '登录'
    },
    // 借口返回错误码处理
    'errorCode': {
        'loading': '加载中...',
        'webCode503': '维护中',
        'webDefault': '请求错误',
        '4001': '调用远程接口异常',
        '401': '您的登录账户已经过期，请您重新登录',
        '503': '系统维护中',
        '0': '成功！',
        '1': '失败！',
        '500': '异常!',
        '1001': '登录失败，获取token失败',
        '1012': '网络异常，请稍后再试！',
        '1101': '用户未授权登录',
        '1102': '用户授权不匹配',
        '4011': 'redis链接异常',
        '4021': '短信发送失败',
        '7001': '参数异常',
        '7002': '数据解析异常',
        '7011': '插入参数错误',
        '7101': '需要重新汇总的数据为空',
        '7102': 'Id不能为空',
        '7103': '当前ip为非CIDR格式',
        '7201': '初始化验证码失败',
        '7202': '验证码校验失败,请重试',
        '7203': '验证码不能为空',
        '7204': '验证码发送过于频繁',
        '7301': '该账户不存在或已被激活,请重新输入',
        '7302': '该账户已被激活,请不要重复激活',
        '7303': '该账户正在激活中，请勿重复激活',
        '7304': '账号不存在',
        '7305': '账户密码错误，请重新输入！3',
        '7306': '您的密码修改次数已达上限，请联系客服处理！',
        '8000': '找不到相关数据',
        '9980': '活动尚未开始',
        '9981': '用户层级不匹配',
        '9983': ' 名称不能为空！',
        '9985': ' 层级信息异常！',
        '9987': ' 保存异常！',
        '9990': ' 自动审核条件设置异常，请确认后重试！',
        '9992': '操作已生效,请勿重复操作',
        '9993': '层级设置数据异常，请检查层级设置后重试！',
        '9994': '未查询到用户信息',
        '9996': '用户不满足活动要求',
        '9997': '活动已过期',
        '10001': '活动尚未开始或已截止',
        '10002': '定时活动异常',
        '10003': '该活动只允许新注册玩家参与',
        '10004': '您的会员层级不在活动允许参与范围内',
        "10006": "活动奖励领取时间尚未开始或已截止",
        '10031': '记录的类型不能修改',
        '10032': '该记录的跳转类型不能修改',
        '10033': '该记录的跳转内容不能修改',
        '10034': '该记录固定编码不能修改',
        '10035': '该记录不能删除',
        '10036': '本活动自动领取最高奖励，无需申请',
        '10062': '签到异常用户不满足活动要求',
        '10091': '不参与厂商数据格式异常，数据格式为key-value格式',
        '10501': 'IP已经添加，无需再次添加',
        '10502': '当跳转类型为外链的时候，跳转内容必须以 http:// 或者 https:// 开头！',
        '11001': '您的申请已提交，请等待客服联系',
        '11031': '至少添加一个层级',
        '11061': '该方案已被使用，无法关闭',
        '11091': '该代理账号可能已被禁用，或被删除，或者代理层级不是代理',
        '11501': '代理账号名已存在，请重新填写',
        '11531': '佣金配置详情信息为空',
        '11801': '手机号加密失败，请稍后再试',
        '12001': '获取游戏链接失败',
        '12002': '获取游戏链接失败',
        '12003': '删除失败，标签下还存在游戏',
        '12104': '该游戏或者该厂商已被删除',
        '12105': '该游戏厂商尚未支持转账确认',
        '12208': '暂无奖池数据',
        '12501': 'queryType必須爲[vendor 或 tags 或 reportFee]其中一種',
        '12532': '起始时间为必填项',
        '12533': '起始时间大于结束时间',
        '12534': '起始时间大于60天',
        '12565': 'gameKindCode不能为空',
        '12566': 'user的id与member的id不匹配',
        '12592': '游戏商不存在vendorCode',
        '12597': '厂商信息不能为空:',
        '13001': '用户不存在',
        '13002': '用户注册时保存数据库失败',
        '13003': '用户检查失败',
        '13004': '用户状态异常',
        '13006': 'member不存在',
        '13007': '您的账号未绑定手机号码，请联系客服处理',
        '13008': '该账号已被冻结，请联系客服',
        '13009': '该账号已被禁用，请联系客服',
        '13010': '由于版本更新您账号超出字符限制，请联系在线客服处理',
        '130011': '用户名或密码错误请重新输入,或联系客服处理',
        '130012': '用户名已存在',
        '13501': '手机号已存在',
        '13502': '用户名id不能为空',
        '13503': '手机号的用户名没有找到',
        '13801': '用户注册失败',
        '13802': '用户更新失败',
        '13803': '远程调用用户更新失败',
        '13901': '会员注册设置异常，请联系客服！',
        '13902': '后台找回密码次数限制配置错误',
        '14001': '用户转账失败',
        '14002': '自动转账失败',
        '14003': '两次稽核的值已经发生变化了',
        '14031': '订单暂未锁定，请先锁定再操作',
        '14032': '该订单已被其他人锁定,您无法操作！',
        '14033': '订单的状态不符合要求！',
        '14034': '提交失败，汇率已变动，请核对并确认金额后重新提交！',
        '14061': '提款申请已提交，请勿重复提交',
        '14062': '提款异常',
        '14091': '您已经绑定过此银行卡',
        '14092': '银行卡账户名不能为空',
        '14093': '绑定银行卡已达到上限',
        '14094': '银行卡姓名与你账号的真实姓名不一致',
        '14095': '绑定数字钱包已经达到上限',
        '14096': '银行卡暂时无法删除，请联系客服处理，谢谢',
        '14097': '该银行卡或数字钱包已被绑定,请重新输入',
        '14098': '您的账号被禁用，请联系客服人员！',
        '14099': '您的钱包账户被禁用，请联系客服人员！',
        '14100': '您输入的账号有误，请联系客服人员！',
        '14101': "请输入长度为6位数字的钱包ID号，谢谢",
        '14501': '存款人不能为空',
        '14502': '支付平台编码和名称为必填项',
        '14503': '钱包用户没有找到',
        '14504': '您的单次提款金额低于下限：',
        '14505': '您的单次提款金额高于上限：',
        '14506': '存款金额必须大于零',
        '14801': '更新失败',
        '14901': '支付密钥没有设置',
        '14902': '获取支付列表的URL没有设置',
        '14903': '获取同步订单的URL没有设置',
        '14904': '订单回调的URL没有设置',
        '14905': '数字货币的充值回调CALLBACK没有设置',
        '14906': '该商户的支付密钥没有设置',
        '14907': '支付相关的字典设置出错了',
        '15001': '领取失败',
        '15002': '领取异常',
        '15034': '获取租户信息异常',
        '15035': '数据已被更改，手动回滚事务',
        '15036': '参与次数已达上限',
        '15037': '参与总金额已达上限',
        '15038': '单次金额已超上限',
        '15061': '全民返利功能尚未开启',
        '15062': '未领取返利金额小于最低领取额度',
        '15063': '请勿重复提交',
        '15064': '正在领取返水中',
        '15091': '余额正在归集，不予查询！！！',
        '15121': '钱包服务异常',
        '15151': '订单已经处理过',
        '15181': '清理冻结失败',
        '15501': '转账金额必须大于1',
        '15502': '转账金额必须大于0',
        '15503': '转账模式不是合法值',
        '15504': '冻结余额不足',
        '15801': '中心钱包转入到游戏商失败！',
        '15802': '游戏商转出到中心钱包失败！',
        '15901': '返水未配置',
        '16001': '平台维护',
        '16002': '平台不存在',
        '16003': '账号已在其它设备登录，请重新登录',
        '100661': '您的签到请求已发送，请勿重复提交',
        '110004': 'Token 无效！',
        '110007': '用户未授权登录！',
        '110009': '当前ip受限',
        '110010': '请求过于频繁，请稍后再试',
        '120001': '该商户不存在',
        '120004': '请求参数中存在null',
        '120014': '用户的中心钱包不存在',
        '120017': '会员等级不存在',
        '120021': '订单号已经存在：',
        '120024': '订单信息不匹配',
        '120025': '支付模式不匹配',
        '120026': '订单状态已经为最终状态,您无法操作！！',
        '120027': '您上一次提款未处理完，请耐心等待！',
        '120029': '订单需要风控审核通过，您才能操作！',
        '120031': '您的每日提现次数已经用完：',
        '120032': '钱包已被禁用，请联系客服！',
        '120050': '严重警告：该用户的密值不匹配',
        '120051': '您的余额不足，无法提现！',
        '120055': '生成密值时发生错误',
        '120056': '您的提款密码错误！',
        '120057': '更新钱包数据失败version不匹配',
        '120070': '用户的余额不足',
        '120093': '获取频繁，请稍后再试！！！',
        '120561': '您填写的邀请码有问题(代理用户不存在，或尚未启用),请核实后重新提交申请',
        '130000': '该币种在链路上的汇率没有找到,请更换币种',
        '999999': '支付异常',
        '1000': '未知错误',
        '130013': '原密码错误，修改失败'
    },
    // 首页 index
    'indexPage': {
        // 公告
        'noticeMessage': '公告通知',
        'more': '更多',

        // 合作专区

        'agencyCommission': '50%代理佣金', // 50%代理佣金
        'agencyCommissioCon1': '高达50%代理佣金',
        'agencyCommissioCon2': '佣金足不出户，月入百万',

        'safeAndReliable': '安全可靠', // 安全可靠
        'safeAndReliableCon1': '每月准时出佣',
        'safeAndReliableCon2': '零风险 零风险 高回报',

        'preferentConstant': '优惠不断', // 优惠不断
        'preferentConstantCon1': '全年度优惠不断',
        'preferentConstantCon2': '满足各种类型玩家需求',

        'finalResource': '资金雄厚', // 资金雄厚
        'finalResourceCon1': '提款快速，金额不封顶',
        'finalResourceCon2': '实力雄厚，资金有保障',

        'dataServices': '全面数据服务', // 全面数据服务
        'dataServicesCon1': '数据信息详尽',
        'dataServicesCon2': '投注/资金各种数据',

        'onlineLicense': '线上执照', // 线上执照
        'onlineLicenseCon1': '视讯，电子游艺，体育，彩票',
        'onlineLicenseCon2': '线上赌场执照，信誉保证',

        'hotBrand': '品牌热度十足', // 品牌热度十足
        'hotBrandCon1': '多年大力推广',
        'hotBrandCon2': '代理可坐享广告品牌效应',

        'platStable': '运营多年平台稳定', // 运营多年平台稳定
        'platStableCon1': '品质卓越，服务到位',
        'platStableCon2': '深受百万玩家信赖',

        // 各个标题
        'sportEvent': 'SPORTS EVENTS', // 热门赛事
        'sportEventCon': 'Select world events to enjoy every day',

        'appDownload': 'APP download', // App下载
        'appDownloadCon': 'Self developed kernel running at high speed',

        'hotSports': 'Hot sports', // 热门赛事
        'hotSportsCon': 'Bring you rich game experience',

        'specialOffer': 'special offer', // 优惠活动
        'specialOfferCon': 'Top mobile betting APP in the industry',

        'cooperZone': 'Cooperation zone', // 合作专区
        'cooperZoneCon': 'High quality service, safe and fast'

    },
    homeIndex: {

        // 各个标题

        hotgamemaintitle: '热门游戏',
        hotgamesecondtitle: '精选热门游戏，每天畅享不断',

        casinomaintitle: '电子游艺',
        casinosecondtitle: '带给你丰富的游戏体验',

        chessmaintitle: '棋牌娱乐',
        chesssecondtitle: '带给你丰富的游戏体验',

        citymaintitle: '娱乐城',
        citysecondtitle: '带给你丰富的游戏体验',

        coomaintitle: '合作专区',
        coosecondtitle: '优质服务 安全快捷',

        hot: '热门',
        recommend: '推荐',
        hotUsual: '常玩',

        sportCom: '体育赛事',
        liveDealer: '视讯直播',
        esportCom: '电竞赛事',
        lotteryCom: '彩票游戏',

        sportComCon: '足球、篮球、网球、羽毛球等体育项目 拥有独特的玩法和精准的赔率!',
        liveDealerCon: '更具真实的玩法，更加真实的场景。 给你带来极具刺激的真人游戏。',
        esportComCon: '世界上最全面的电竞赛事竞猜，让您无时无刻体验到电竞盛宴。',
        lotteryComCon: '彩票的感官刺激，种类繁多的彩票游戏邀您一起体验!',

        downApp: 'APP下载',
        actDis: '优惠活动',
        cooper: '合作专区',
        online: '在线客服'
    },
    // 首页 
    'indexPage': {
        noMoreTipToday: '今日不再提示',
        'notice': '最新公告',
        'discount': '优惠活动',
        'more': '更多',
        'disIntro': '电子鸿运当头 做任务天天奖',
        'viewDis': '查看优惠',
        'enterLobby': '进入大厅',
        'casino': '电子游艺',
        'live': '真人娱乐',
        'fish': '捕鱼游戏',
        'chess': '棋牌',
        'reviewReward': '大奖回顾',
        'startGame': '开始游戏',
        'tryOnce': '试玩体验',
        'noshow': '不再显示',
        'newVersion': `新版${skin}APP抢先下载！`,
        'text2': '防劫持下载、教程，拒绝虚假诈骗',
        'text3': '存款操作演示',
        'text4': `${skin}官方APP下载，随心所欲自由畅玩`,
        'detail': `✿尊敬的${skin}会员，一直有不法分子冒用“${skin}”的名义，采取虚假效仿网站、钓鱼网站、App网页拦截，微信公众号等方式进行诱骗，请大家千万不要上当受骗，以免造成损失。${skin}再三申明，绝无其他合作公司或子公司，也没有和任何其他公司合并。网站所有优惠都以官网为准。如有任何疑问，请联系客服咨询！`,
        'gongxi': '恭喜会员',
        'zai': '在',
        'zhongjiang': '中奖',
        'yuan': '元',
        'pleaseLogin': '请登录',
        'repair': '维护中',
        'failed': '进入游戏失败，请稍后重试！',
    },
    // 二级游戏
    'secondGame': {
        'intro1': '现场360度视角，推荐最好牌路',
        'intro2': '多桌同时投注，让您乐在其中',
        'intro3': '独创6张牌先发，多种创新玩法',
        'intro4': '独创真人、电游同厅共玩',
        'input': '请输入游戏名称',
        'newReward': '最新中奖',
        'hot': '热门推荐',
        'member': '会员',
        'reward': '中奖',
        'enter': '进入游戏',
        'nothing': '当前输入为空',
        'pleaseLogin': '请登录',

    },
    // 大奖回顾
    'prize': {
        'yuan': '元',
        'million': '百万红包',
        'like': '喜气红包',
        'bet': '投注金额',
        'rewrad': '暴奖金额',
    },
    'enterGame': {
        'pleaseLogin': '请登录',
    },
    // 登录
    "loginPage": {
        'memberLogin': '用户登录', // 登录
        'login': '用户登录', // 登录
        'account': '账号',
        'password': '密码',
        'verifyCode': '验证码',
        'accountP': '请输入账号', // 请输入账号
        'passwordP': '请输入登录密码', // 请输入登录密码
        'verifyCodeP': '请输入验证码', // 请输入图形验证码
        'fastRegister': '注册', // 注册
        'retrievePassword': '找回密码', // 找回密码
        'regain': '重新获取', // 重新获取
        'accountE': '账号不能为空', // 账号不能为空
        'passwordE': '密码不能为空', // 密码不能为空
        'verifyCodeE': "验证码不能为空",
        'firstVerify': "请先通过行为验证", // 请先通过行为验证
        'loginSuccess': "恭喜您，登录成功", // 登录成功
        'passwordLeak': '您的登录密码已确认，请及时修改密码，以防泄露！', // 您的登录密码已确认，请及时修改密码，以防泄露！
        'gotIt': "知道了",
        'logExceptionVerifyFront': '您的验证信息错误，还有', // 您的验证信息错误，还有
        'logExceptionVerifyBack': '次验证机会，超过次数会冻结账号哦！', // 次验证机会，超过次数会冻结账号哦！
        'clickBtnToVerify': "点击按钮验证",
        'loading': "正在加载...",
        'verifySuccess': '验证成功',
        'verifyFail': '验证失败',
        'getError': '获取错误',
        'loadFail': '加载失败，请重试',
        'notAccount': "还没有账号？", //还没有账号？
        'fastRegister': '立即注册', //立即注册
    },
    // 异常登录验证
    'validLoginPage': {
        'title': '异常验证',
        'desc': "系统检测到您的账户登录地区异常，请填写你的账户真实姓名进行验证！",
        'realName': '姓名',
        'realNameP': "请输入姓名",
        'submitBtn': "提交验证"
    },
    // 注册
    "registerPage": {
        'memberRegister': '会员注册',
        'register': "免费开户",
        'confirmPsw': "确认密码",
        'inviteCode': '邀请码',
        'phone': '手机号',
        'birthday': '生日',
        'wechat': '微信',
        'qq': 'QQ',
        'email': '邮箱',
        'address': '地址',
        'inviteCodeP': '请输入邀请码',
        'optional': '（选填）',
        'phoneP': '请输入手机号码',
        'realNameP': '请输入姓名',
        'sexP': '请选择性别',
        'male': '男',
        'female': '女',
        'birthdayP': '请输入生日',
        'wechatP': '请输入微信号码',
        'qqP': '请输入QQ号码',
        'emailP': '请输入邮箱地址',
        "addressP": '请输入联系地址',
        "agree": '已经满18周岁，并且同意本站',
        'userAgreement': '《用户使用协议》',
        'haveAccount': '已有账号？',
        'fastLogin': '立即登录',
        'sex': "性别",
        'cancel': "取消",
        'confirm': '确定',
        'inviteCodeE': '邀请码不能为空！',
        'confirmPswE': '确认密码不能为空！',
        'phoneE': '手机号不能为空！',
        'realNameE': '姓名不能为空！',
        'birthdayE': '生日不能为空！',
        'wechatE': '微信号不能为空！',
        'qqE': 'QQ号不能为空！',
        'emailE': '邮箱不能为空！',
        'addressE': '地址不能为空！',
        'codeE': '验证码不能为空！',
        'firstAgree': '请先勾选用户使用协议！',
        'inviteCodeV': '邀请码必须为字母或数字',
        'accountV': '账号必须为4~15位数字与字母组合',
        "accountPostV": "账号必须为4~13位数字与字母组合",
        'passwordV': '密码6-15位,字母数字符号至少两种组合',
        'pswIscPsw': '密码与确认密码必须一致',
        'phoneV': '手机格式不正确',
        'wechatV': '微信号码不存在！',
        'qqV': 'QQ号码不存在！',
        'emailV': '邮箱地址不存在！',
        'registerSuccess': "恭喜您，注册成功",
        'inviteCodeF': '请输入字母或数字'
    },
    // 忘记密码
    'forgetPswPage': {
        'retrievePassword': '找回密码',
        'firstStep': '第一步:验证账号信息',
        'isRetrievePassword': "有问题？请联系",
        'onlineService': '在线客服',
        'confirmToSubmit': "确认提交",
        'secStep': "第二步:短信验证",
        'SMSCodeP': "请输入短信验证码",
        'getCode': "获取验证码",
        'thirdStep': '第三步:修改新密码',
        'newPsw': '新密码',
        'newPswP': '请输入新密码',
        'reNewPswP': "请再次输入新密码",
        'codeE': '验证码不能为空',
        'Tips': '温馨提示',
        'gotIt': '知道了',
        'phoneCodeE': "短信验证码不能为空！",
        'newPswE': "新密码不能为空！",
        'newPswValid': '密码6-15位,字母数字符号至少两种组合',
        'newIsConfirmPsw': '新密码与确认密码必须一致',
        'modifySuccess': '修改成功，5S后进入登录界面',
        'enterLogin': '进入登录页',
        'modifySuccessA': "修改成功，",
        'aEnterLogin': 'S后进入登录界面'
    },
    // 个人资料页面
    'personalPage': {
        'personalData': '个人资料',
        'nickname': '昵称',
        'nicknameP': '请输入昵称',
        'submit': '提交',
        'accountPsw': '账号密码',
        'tradePsw': '交易密码',
        'modify': '修改',
        'set': '设置',
        'updateSuccess': "更新会员成功",
        'birthdayP': '年/月/日',
        'phone': "联系电话",
        'email': "邮箱地址",
        'qq': "联系QQ"
    },
    // 代理首页
    'agentHome': {
        'title': "合作专区",
        'advantage': '大优势 让你不可抗拒',
        'titleDesc': '优质服务 安全快捷',
        'desc': '亚洲顶级线上博彩公司，最具公信力，更具高端品质，深受广大玩家喜爱及支持，同时致力于打造线上最高端的代理合作平台，零成本，高回报。为“微商、电商”争相选择之最佳创业投资项目。加入我们，开启您的财富梦想之路！',
        'lang_1': '八大优势让你不可抗拒',
        'lang_21': "高达50%的代理佣金",
        'lang_22': "足不出户月入百万",
        'lang_31': "每月准时出佣",
        'lang_32': "零风险,零费用,高回报",
        'lang_41': "全年度优惠不断",
        'lang_42': "满足各种类型玩家需求",
        'lang_51': "提款快速，金额不封顶",
        'lang_52': "实力雄厚，资金有保障",
        'lang_61': "数据信息详尽",
        'lang_62': "投注/资金各种数据",
        'lang_71': "视讯、电子游艺、体育、彩票",
        'lang_72': "线上赌场执照，信誉保证",
        'lang_81': "多年大力推广",
        'lang_82': "代理可坐享广告品牌效应",
        'lang_91': "品质卓越，服务到位",
        'lang_92': "深受百万玩家信赖",
        'lang_2_title': '50% 代理佣金',
        'lang_3_title': '安全 可靠',
        'lang_4_title': '优惠 不断',
        'lang_5_title': '资金 雄厚',
        'lang_6_title': '全面 数据服务',
        'lang_7_title': '线上 执照',
        'lang_8_title': '品牌 热度十足',
        'lang_9_title': '运营 多年平台 稳定',
        'lang_commissionPlan': "代理佣金方案",
        'lang_joinUs': "加入我们",
        'lang_contactService': "加盟请咨询客服",
        'commissionTitle': "代理佣金方案",
        'contactUs': "联系我们"
    },
    // 代理注册
    'agentRegister': {
        'title': "代理申请",
        'lang_accountP': "请输入申请账号",
        'lang_passwordP': '请输入账户密码',
        'lang_rePasswordP': "请再次输入账户密码",
        'lang_fastApply': '立即加入',
        'agreement': "加盟协议",
        'accountPostF': '请输入4~13位数字与字母组合',
        'accountF': '请输入4~15位数字与字母组合',
        'passwordF': '密码6-15位,字母数字符号至少两种组合'
    },
    // 提交成功
    'agentResult': {
        'applySubmited': "申请已提交，",
        'contactAttache': '请在3日内与专员联系开通，并提供您的代理编号和代理链接。'
    },
    // 加盟协议
    'agreement': {
        'lang_title': "【加盟协议】",
        'lang_para1': "一、游戏平台对代理联盟的权利与义务：",
        'lang_para11': "游戏平台客服部会登记联盟的会员并会观察他们的投注状况。联盟及会员必须同意并遵守游戏平台的会员条例，政策及操作程式。游戏平台保留拒绝或冻结联盟/会员帐户权利。",
        'lang_para12': "代理联盟可随时登入介面观察旗下会员的下注状况及会员在网站的活动概况。游戏平台的客服部会根据代理联盟旗下的会员计算所得的佣金。",
        'lang_para13': '游戏平台保留可以修改合约书上的任何条例，包括: 现有的佣金范围、佣金计划、付款程式、及参考计划条例的权力，游戏平台会以电邮、网站公告等方法通知代理联盟。 代理联盟对于所做的修改有异议，代理联盟可选择终止合约，或洽谈客服人员反映意见。 如修改后代理联盟无任何异议，便视作默认合约修改，代理联盟必须遵守更改后的相关规定。',
        'lang_para2': "二、代理联盟对游戏平台的权力及义务：",
        'lang_para21': '代理联盟应尽其所能，广泛地宣传、销售及推广游戏平台，使代理本身及游戏平台的利润最大化。代理联盟可在不违反法律下，以正面形象宣传、销售及推广游戏平台，并有责任义务告知旗下会员所有游戏平台的相关优惠条件及产品。',
        'lang_para22': "代理联盟选择的游戏平台推广手法若需付费，则代理应承担该费用。",
        'lang_para23': "任何游戏平台相关资讯包括: 标志、报表、游戏画面、图样、文案等，代理联盟不得私自复制、公开、分发有关材料，游戏平台保留法律追诉权。 如代理在做业务推广有相关需要，请随时洽游戏平台。",
        'lang_para3': "三、规则条款：",
        'lang_para31': "各阶层代理联盟不可在未经游戏平台许可情况下开设双/多个的代理帐号，也不可从游戏平台帐户或相关人士赚取佣金。请谨记任何阶层代理不能用代理帐户下注，游戏平台有权终止并封存帐号及所有在游戏中赚取的佣金。",
        'lang_para32': "为确保所有游戏平台会员账号隐私与权益，游戏平台不会提供任何会员密码，或会员个人资料。各阶层代理联盟亦不得以任何方式取得会员资料，或任意登入下层会员账号，如发现代理联盟有侵害游戏平台会员隐私行为，游戏平台有权取消代理联盟红利，并取消代理联盟账号。",
        'lang_para33': "代理联盟旗下的会员不得开设多于一个的帐户。游戏平台有权要求会员提供有效的身份证明以验证会员的身份，并保留以IP判定是否重复会员的权利。如违反上述事项，游戏平台有权终止玩家进行游戏并封存帐号及所有于游戏中赚取的佣金。",
        'lang_para34': "代理联盟不可为自己或其他联盟下的有效投注会员,只能是公司直属下的有效投注会员, 代理每月需有3个下线有效投注会员（每月至少上线3次进行正常投注），如有违反联盟协议游戏平台有权终止并封存帐号及所有在游戏中赚取的佣金。",
        'lang_para35': "如代理联盟旗下的会员因为违反条例而被禁止享用游戏平台的游戏，或游戏平台退回存款给会员。 合约内的条件会以游戏平台通知接受代理联盟加入后开始执行。游戏平台及代理联盟可随时终止此合约，在任何情况下，代理联盟如果想终止合约，都必须以书面/电邮方式提早于七日内通知游戏平台。 代理联盟的表现会3个月审核一次，如代理联盟已不是现有的合作成员则本合约书可以在任何时间终止。如合作伙伴违反合约条例，游戏平台有权立即终止合约。",
        'lang_para36': "在没有游戏平台许可下，代理联盟不能透露及授权游戏平台S相关密资料，包括代理联盟所获得的回馈、佣金报表、计算等;代理联盟有义务在合约终止后仍执行机密档及资料的保密。在合约终止后，代理联盟及游戏平台将不须要履行双方的权利及义务。终止合约并不会解除代理，联盟于终止合约前应履行的义务。"
    },
    // 公告消息
    'noticeInfo': {
        'title': '公告消息',
        'msgDetailTitle': '通知详情',
        'noticeDetailTitle': '公告详情',
        'messageNavTitle': '站内信',
        'noticeNavTitle': '公告',
        'deleteAll': '全部删除',
        'readedAll': '全部已读',
        'msgEmpty': '一条通知都没呢...',
        'noticeEmpty': '一条公告都没呢...',
        'delete': '删除',
        'back': '返回',
        'msgAllDeleteSuccess': '通知全部删除成功!',
        'msgAllReadSuccess': '通知全部已读成功!',
        'msgDeleteSuccess': '通知删除成功!',
        'tip': "温馨提示: 站内信的消息每周一上午10点会自动清除前2周记录！",
        'sectionTitle': "标题",
        'time': '时间',
        'status': '状态',
        'operation': '操作',
        'unread': '未读',
        'readed': "已读"
    },
    // 优惠活动页面
    "activityPage": {
        'return': '返回',
        'title': '活动中心',
        'longTime': '长期活动',
        'limitTime': '限时活动',
        'activityTime': '活动时间',
        'ThereNOdata': '没有更多数据了',
        "actDetail": '活动详情',
        "actcomputed": '活动完成情况',
        "lookList": '查看活动记录',
        "actList": '活动记录',
        "yuan": '元',
        "ongoing": '进行中',
        "unfinished": '未完成',
        "WaitingAudit": '等待审核',
        "complete": '已完成，奖励已发放至中心钱包',
        'Immediately': '立即参与',
        'Contactcustomer': '联系客服',
        'date': '日期',
        "theConditions": '完成条件',
        'completion': '完成状态',
        "month": '月',
        'day': '日',
        "Participate": '参与成功',
        'notapproved': '审核未通过',
        'Loading': '正在加载...',
        'ThereNOdata': '没有更多数据了',
        'Pullmore': '下拉显示更多',
        'status': '活动状态',
        "actend": '活动截止',
        'actShuo': '活动说明',
        'title1': '全部优惠',
        'title2': '限时活动',
        'title3': '长期活动',
        'title4': '永久',
        'title5': '关闭',
        'hotAct': '热门活动',
    },
    // 彩金页面
    "lotteryGold": {
        "LotterCollection": "彩金",
        "all": '全部',
        "available": '可领取',
        "Received": '已领取',
        "Expired": '已过期',
        "getnow": '立即领取',
        "Validuntil": '领取有效期截止',
        "nodata": '暂无数据',
        "flowdemand": '流水要求',
        "bei": '倍',
        "prompt": '提示',
        "succeeded": '领取成功',
        "toSee": '请前往余额查看',
        "Isee": '我知道了',
        "beencollected": '彩金已经领取过啦',
        "unableClaim": '已过期无法领取！',
        "LotterCo": "彩金领取",
        'Loading': '正在加载...',
        'ThereNOdata': '没有更多数据了',
        'Pullmore': '下拉显示更多',
        'cancel': '取消'
    },
    // 安全中心页面
    'safetyPage': {
        'loginPassword': '登录密码',
        'Tomodify': '去修改',
        'WithdPassword': '取款密码',
        'Tosettings': '去设置',
        'OriginalPassword': '请输入原登录密码',
        'withdrawalPassword': '请输入原取款密码',
        'EnterOldPassword': '请输入原密码',
        'Newloginpassword': '请输入新登录密码',
        'Newwithpassword': '请输入新取款密码',
        'Enternewpassword': '请输入新密码',
        'Confirmnewpassword': '确认新密码',
        'EnterPasswordAgain': '请再次输入密码',
        'SetPassword': '设置密码',
        "ConfirmPassword": '确认密码',
        'Newphonenumber': '新手机号',
        'enternewnumber': '请输入新手机号码',
        'VerificationCode': '验证码',
        'entercode': '请输入验证码',
        'GetCaptcha': '获取验证码',
        'confirm': '确定',
        'Confirmsubmit': '确认提交',
        'Pleasecontact': '有问题？请联系',
        'OnlineService': '在线客服',
        'Changepassword': '修改登录密码',
        'Modifywithdpassword': '修改交易密码',
        'Setwithdpassword': '设置交易密码',
        'Modifyphonenumber': '修改手机号码',
        'Modifysucceeded': '修改成功',
        'Setupsucceeded': '设置成功',
        'originalpassword': '原密码必须为6-15位,字母数字符号至少两种组合',
        'originalwithdrawal': '原取款密码必须为6位数字',
        'newwithdrawal': '新取款密码必须为6位数字',
        'passwordcannotempty': '原密码不可为空',
        'notthesame': '两次输入的密码不一致',
        'Newpassword': '新密码必须为6-15位,字母数字符号至少两种组合',
        'Failednumber': '绑定手机号失败',
        'Bindsuccessfully': '手机号绑定成功',
        'Mobileempty': '手机号不可为空',
        'IncorrectPhone': '手机格式不正确',
        'Failedtocode': '获取手机验证码失败',
        'codecomplete': '获取手机验证码完成',
        'saftCenter': '安全中心',
        'newPass': '新密码',
        "oldPass": '原密码',
        'agagin': '再次输入',
        'Loginsuc': '修改登录密码成功',
        "Transactionsuc": '设置交易密码成功',
        'ransactionsuc': '修改交易密码成功',
        'tip': '温馨提示：修改后请牢记您的资金密码。',
        'tip1': '当前您所使用的资金密码',
        'tip2': '6位数字组合',
        'tip3': '必须与新密码一致',
        'tip4': '密码必须为6位数字！',
        'tip5': '当前您所使用的登录密码',
        'tip6': '密码6-15位,字母数字符号至少两种组合',
        'tip7': '温馨提示：修改后请牢记您的登录密码。',
        'tip9': '忘记密码',
        "tip10": '您的账户安全等级',
        "tip11": '还有',
        "tip12": '项未通过验证/设定',
        "tip13": '资金密码',
        "tip14": '银行卡绑定后，提款操作时需要进行资金密码确认，以提高您的资金安全性。',
        "tip15": '绑定邮箱',
        "tip16": '修改',
        "tip17": '设置',
        "tip18": '绑定邮箱',
        "tip19": '绑定邮箱可增加账号安全级别，也可以确保在邮箱正常的情况下取回登录密码。',
        "tip20": '绑定手机',
        "tip21": '与您的账号绑定后，在资金提现、修改密码等重要时刻，可以加强您的账号安全。',
        "tip22": '绑定QQ',
        "tip23": '请联系客服进行修改！',
        "tip24": '低级',
        "tip25": '高级',
        "tip26": '中等',
        'tip27': '已绑定',
        'tip28': '未绑定',
        'tip29': '安全验证',
        'tip30': '资金密码',
        'tip31': '登录密码',
        'tip32': '设备管理',




    },
    // 签到
    "signIn": {
        'limitTime': '限时优惠',
        'noShow': '不再弹出此提示',
        "signIn": '签到',
        "actTime": '活动时间',
        "to": '至',
        "di": '第',
        "day": '天',
        "Signnow": '立即签到',
        "Checkin": '签到领取',
        "requirements": '流水要求',
        "bei": '倍',
        "gitNow": '立即领取',
        "tip": '提示',
        "success": '领取成功,请前往余额查看',
        "Isee": '我知道了',
        "actDet": '活动说明',
        "loading": '加载中',
        'long': '长期',
        'cancel': '取消',
        'lianxu': '您已连续签到',
    },
    // 个人中心
    "myPage": {
        "recharge": "财务中心",
        "drawing": "交易记录",
        "highRebate": "全民返利",
        "information": "个人资料",
        "mode": "自助优惠",
        "report": "游戏记录",
        "security": "交易记录",
        "Notice": "公告消息",
        "cooperation": "活动记录",
        "gle": "安全管理",
        "withdrawals": "彩金管理",
        "Deposit": "会员存款",
        treasure: "利息宝",
        Rebate: "返利",
        bank: '收款方式管理',
        drawing: '会员提款',
        userInfo: '基本信息',
        complete: '完善资料',
        "water": "累计返水",
        "element": "元",
        "full": "满",
        "rec": "元可领取",
        "receive": "领取",
        "getBackwater": "返水领取",
        "once": "立即领取",
        "see": "查看详情",
        "tipErr": "返水额度不满足条件，无法领取！",
        "tipstitle": "温馨提示",
        "know": "我知道了",
        titleAlert: '领取成功',
        "tipsRes": "请到中心钱包查看余额",
        "success": "返水刷新成功",
        "failure": "返水额度刷新失败，请重试！",
        requirements: "流水要求",
        Times: "倍",
        get: '领取'
    },
    // 充值
    "rechargePage": {
        "headerTitle": "存款",
        "null": "暂时没有该存款方式",
        getMode: '支付方式',
        "passageway": "充值通道",
        "seleBank": "选择银行",
        "name": "存款姓名",
        'address': '存款地址',
        'addressPlaceholder': '请输入存款地址',
        'tipsAddress': '为确保及时到账，请务必输入正确的存款地址',
        "tipsName": "为确保及时到账，请务必输入正确的存款姓名",
        "inputName": "请输入存款姓名",
        "setmoney": "充值金额",
        "inputMoney": "请输入存款金额",
        "minMoney": "单笔最低入款金额",
        "element": "元",
        "maxMoney": "最高入款金额",
        "tipstitle": "温馨提示",
        "tips1": "1.请注意页面显示的最小转账额度，小于最小充值金额的充值将不会上账且无法退回；",
        "tips2": "2.您充值至上述地址后，需要整个网络节点的确认，请耐心等待，我们收到数字货币后会立即向您的账户上账对应金额，若长时间未收到，可联系客服咨询",
        "tips3": "3.转账时请务必核对币种以及链名称，若提交错误资产不可找回。",
        "tips4": "4.页面显示汇率只供参考，由于汇率存在波动，上账时将根据最新的汇率比例进行计算。",
        "confirm": "确认充值",
        "next": "下一步",
        "setparagraph": "公司入款",
        "online": "线上入款",
        "currency": "数字货币",
        "vip": "VIP专享",
        "tipsnull": "当前无充值信息，请联系客服！",
        "gotIt": "知道了",
        "determine": "确定",
        "range": "金额输入不在范围",
        "retry": "该通道不可用请重试",
        "error": "错误码",
        "bankSelect": "请选择银行卡",
        errortext: '加载失败',
        tipsMoney: '温馨提示: 如当前支付方式未能支付成功，请您尝试其他支付方式进行支付！',
    },
    // 提款
    "accountPage": {
        "headerTitle": "取款",
        "balance": "账户余额",
        "element": "元",
        "collection": "一键归集",
        "getMode": "请选择提款方式",
        "tipsnull": "一张银行卡都没有呢",
        "addMode": "添加取款方式",
        "addbank": "添加银行卡/数字货币/三方钱包",
        "addMoney": "添加数字货币钱包",
        "cancel": "取消",
        "more": "更多",
        "down": "下拉刷新",
        "away": "收起",
        "warning": "点击间隔10s，请勿重复操作！",
        "Refresh": "刷新余额成功",
        "hand": "归集中",
        "handRes": "归集成功！",
        "handErr": "归集失败，请重新尝试！",
        "setpassword": "您还未设置交易密码， 是否前往设置？",
        "forward": "立即前往",
        "tipsbank": "您最多只能绑3张银行卡！如需调整，请联系客服！",
        "tipsM": "您最多只能绑3种数字货币！如需调整，请联系客服！",
        "tipsW": "您最多只能绑3个origo钱包！如需调整，请联系客服！",
        "addWallet": "添加origo钱包",
        wallet: "三方钱包",
        next: '下一步',
        phoneget: '请验证手机号提款',
        phone: '手机号',
        inputPhone: '请输入手机号',
        inputcode: '请输入验证码',
        code: '验证码',
        determine: '确定',
        getcode: '获取验证码',
        getmoneyMode: '收款方式',
        phoneErr: '手机号格式错误',
        getcodeSuee: '获取验证码成功',
        'mobile': '绑定手机号成功',
        game: '游戏平台',
        accountMoney: '主账户额度'
    },
    // 提款
    "drawingPage": {
        "headerTitle": "取款",
        "getbank": "提款银行卡",
        "getMoney": "提款金额",
        "all": "全部",
        "sure": "当前可提现金额",
        "element": "元",
        "actual": "实际到账金额",
        "refresh": "刷新",
        "procedures": "提现手续费",
        "expenses": "行政费用",
        "discount": "优惠扣除",
        "pawss": "交易密码",
        "inputPwass": "请输入交易密码",
        "problem": "有问题？请联系在线客服",
        "withdrawal": "确认提款",
        "selectBank": "选择银行",
        "inputMoney": "请输入提款金额",
        "integer": "提款金额必须为正整数",
        "confirmation": "是否确认提款？",
        "cancel": "取消",
        "determine": "确定",
        "successful": "申请成功，请等待平台审核",
        "fail": "提款失败请重试",
        "beyond": "金额超限，请输入正确金额",
        "currency": "数字货币钱包",
        "wallet": "三方钱包",
        "getpwass": "找回密码",
        "selecurrency": "选择数字货币",
        "Insufficient": "您的余额不足，无法提现！",
        "lower": "您的取款额度低于单次取款限额:",
        "higher": "您的取款额度高于单次取款限额",
        "toolow": "您的实际获得额度过低，无法提现！",
        "minAmount": "最小提现金额",
        'gotIt': '知道了',
        'sucRefresh': '刷新成功',
        "tip": '提示',
        "tips1": "1.请注意页面显示的最小转账额度，小于最小充值金额的充值将不会上账且无法退回；",
        "tips2": "2.您充值至上述地址后，需要整个网络节点的确认，请耐心等待，我们收到数字货币后会立即向您的账户上账对应金额，若长时间未收到，可联系客服咨询",
        "tips3": "3.转账时请务必核对币种以及链名称，若提交错误资产不可找回。",
        "tips4": "4.页面显示汇率只供参考，由于汇率存在波动，上账时将根据最新的汇率比例进行计算。",
        mode: '取款方式',
        goback: '上一步',
        errorTips: '您的钱包已被冻结，请联系客服！',
        nullbank: '未添加银行卡',
        now: '现在添加'
    },
    // 银行卡列表
    "bankCardPage": {
        "title": "收款方式管理",
        "tipnull": "这里空空的 \n 什么都没有",
        "addMethod": "我的银行卡",
        "addBank": "添加银行卡",
        "addMoney": "添加数字货币",
        "wallet": "添加三方钱包",
        "wallets": "三方钱包",
        "addBankmode": "收款方式",
        "username": "账户姓名",
        "inputName": "请输入账户姓名",
        "bankName": "银行名称",
        "bankCode": "银行卡号",
        "inputCode": "请输入您的新银行卡号",
        "tipsCode": "银行卡号必须大于12位小于19位",
        "branch": "支行名称",
        "inputbranch": "请输入支行名称",
        "Submit": "确认提交",
        "getcode": "获取验证码",
        "selectBank": "请选择银行",
        "selectBank1": "选择银行",
        "determine": "确定",
        "addRes": "添加成功",
        "addTitle": "数字货币",
        "type": "选择币种",
        "name": "链名称",
        "adress": "钱包地址",
        "add": "确认添加",
        "seleType": "请选择币种类型",
        "tipName": "请填写真实姓名再添加银行卡",
        "tipsPawss": "请先设置取款密码再添加银行卡",
        "again": "重新添加",
        "input": "请输入",
        "pType": "请选择类别",
        "inputAddress": "请输入钱包地址",
        "linkAddress": "请输入链地址",
        "account": "origo钱包账户",
        "inputWallet": "请输入钱包账户",
        "tipsTitle": "提示",
        tips1: '为了您的资金能迅速到账，请确保选择的货币名称与链名称正确无误',
        tips2: '为了您的资金迅速到账，请确保填写姓名与银行开户姓名一致',
        addMode: '添加收款方式',
        bankcard: '银行卡',
        cancel: '取消',
        code2: '确认卡号',
        bankcode2: '请再次输入您的银行卡号',
        bankcode3: '由12-19位数字组成',
        back: '返 回',
        text1: '不可重复添加相同的银行',
        text2: '不可重复添加相同的钱包',
        tips: '温馨提示：锁定银行卡后，不可修改银行相关信息（开户姓名无法修改，否则无法提款!）',
        errCode: '两次输入银行卡号不一致',
        errwalletcode: '请输入长度为6位数字的钱包ID号，谢谢',
        phone: '手机号',
        phonecode: '验证码',
        phoneInput: '请输入手机号',
        codeInput: '请输入验证码',
        'phoneEorro': '手机号格式错误',
        getcodeSuee: '获取验证码成功',

    },
    //vip等级
    vip: {
        level: 'VIP等级',
        grade: '等级',
        reached: '达成条件',
        tips: '提现次数',
        deposit: '存款',
        Valid: '有效投注',
        Times: '次',
        contact: '联系客服',
        download: 'APP下载',
        mobile: "访问移动端",
        'maintanence': '维护中',
        'gotologin': '您还未登录请前往登录',
        copy: '复制',
        copyS: '复制成功',
        copyF: '复制失败'
    },
    header: {
        text1: '存款',
        text2: '取款',
        text3: '彩金',
        text4: '我的资料',
        text5: '收款方式',
        text6: '游戏记录',
        text7: '交易记录',
        text8: '公告信息',
        text9: '退出登录',
        text10: '首页',
        text11: '体育',
        text12: '电子',
        text13: '棋牌',
        text14: '彩票',
        text15: '视讯',
        text16: '电竞',
        text17: '优惠',
        login: '登录',
        register: '注册',
        VIP: '普通用户'
    },
    footer: {
        con: '政府颁发执照，安全有保障！支持微信，支付宝，银联服务，24小时取款，5分钟到账！受国际协会认可的合法公司。进行注册并娱乐前，请确保您年满18周岁！'
    },
    record: {
        text1: '年 /月 /日',
        text2: '查询',
        text3: '重置',
        text4: '一条记录也没有呢...',
        text5: '复制成功！',
        text6: '复制失败！'
    },
    gameRecord: {
        title: '游戏记录',
        text1: '每条投注的数据将会有一定的时间延迟，仅供参考使用',
        text2: '游戏平台:',
        text3: '请选择',
        text4: '投注金额:',
        text5: '时间筛选:',
        text6: '单号',
        text7: '复制',
        text8: '游戏平台',
        text9: '游戏名称',
        text10: '投注时间',
        text11: '派彩时间',
        text12: '投注金额',
        text13: '有效投注',
        text14: '派彩金额',
        text15: '盈亏金额',
        text16: '总投注:',
        text17: '总派金:',
        text18: '总有效投注:',
        text19: '总盈亏金额:'
    },
    tradingRecord: {
        title1: '交易记录',
        title2: '返水详情',
        text1: '只可查询近一个月的交易记录，如需更多信息请联系客服查询',
        text2: '交易类型：',
        text3: '交易状态：',
        text4: '交易时间：',
        text5: '返水金额：',
        text6: '选择时间：',
        text7: '订单号',
        text8: '交易时间',
        text9: '金额',
        text10: '状态',
        text11: '支付方式',
        text12: '支付成功',
        text13: '提款方式',
        text14: '出款成功',
        text15: '类型',
        text16: '成功',
        text17: '状态',
        text18: '返水类型',
        text19: '详情',

        text20: '活动名称',
        text21: '存入时间',
        text22: '利率',
        text23: '结息时间',
        text24: '金额',
        text25: '利息',
        text26: '本利总额',
        text27: '已存放',
        text28: '状态',
        text29: '操作',
        text30: '时间',
        text31: '游戏平台',
        text32: '游戏名称',
        text33: '流水',
        text34: '返水',
        text35: '利息钱包：',
        text36: '总领取利息：',
        text37: '利息宝领取',
        text38: '包含利息',
        text39: '元',
        text40: '利息流水要求：',
        text41: '倍',
        text42: '提前领取',
        text43: '提前领取额度，只能领取部分利息，是否确认提前领取？',
        text44: '取消',
        text45: '立即领取',


        text46: '今日',
        text47: '昨日',
        text48: '近7日',
        text49: '近30日',
        text50: '全部',
        text51: '计息中',
        text52: '已到期',
        text53: '已领取',
        text54: '充值记录',
        text55: '银行转账',
        text56: '提款记录',
        text57: '返水记录',
        text58: '其它',
        text59: '利息宝',
        text60: '领取成功！',
        text61: '未处理',
        text62: '处理中',
        text63: '充值成功',
        text64: '充值失败',
        text65: '关闭',
        text66: '待支付',
        text67: '支付中',
        text68: '支付成功',
        text69: '支付失败',
        text70: '已关闭',
        text71: '线下银行卡支付',
        text72: '线下二维码支付',
        text73: '线上支付',
        text74: '手动上分',
        text75: '数值货币支付',

        text76: '待支付',
        text77: '支付中',
        text78: '支付成功',
        text79: '支付失败',
        text80: '支付宝扫码',
        text81: '微信扫码',
        text82: '微信H5',
        text83: '支付宝H5',
        text84: '银联扫码',
        text85: '银联转账',
        text86: '其它',
        text87: '未处理',
        text88: '处理中',
        text89: '提款成功',
        text90: '提款失败',
        text91: '关闭',
        text92: '待出款',
        text93: '出款中',
        text94: '出款成功',
        text95: '出款失败',
        text96: '关闭',
        text97: '银行卡提款',
        text98: '手动下分',
        text99: '数值货币提款申请',
        text100: 'origo钱包提款',
        text101: '未处理',
        text102: '处理中',
        text103: '成功',
        text104: '失败',
        text105: '关闭',
        text106: '待领取',
        text107: '已过期',
        text108: '成功',
        text109: '失败',
        payChannel1: '线下入款优惠',
        payChannel2: '线上入款优惠',
        payChannel3: '手动上分',
        payChannel4: '手动存款优惠上分',
        payChannel5: '手动返水优惠上分',
        payChannel6: '手动活动优惠上分',
        payChannel7: '自动活动优惠上分',
        payChannel8: '手动下分-存款',
        payChannel9: '手动下分-优惠活动',
        payChannel10: '手动下分-人工存款反水',
        payChannel11: '手动下分-存款优惠',
        payChannel12: '手动上分-优惠活动',
        payChannel13: '手动上分-人工存款返水',
        payChannel14: '手动上分-存款优惠',
        payChannel15: '手动上分-其他',
        payChannel16: '手动上分彩金',
        payChannel17: '活动上分彩金',
        payChannel18: '手动上分彩金-人工存款返水',
        payChannel19: '手动上分彩金-存款优惠',
        payChannel20: '手动上分彩金-优惠活动',
        payChannel21: '手动上分-其他彩金',
        payChannel22: '数值货币优惠上分',
        payChannel23: '救济金上分',
        payChannel24: '救济金彩金',
        payChannel25: '每日签到上分',
        payChannel26: '全民返利',
        payChannel27: '其他',
        payChannel28: '利息宝存入',
        payChannel29: '利息宝本金提取',
        payChannel30: '利息宝利息提取',

        payChannel31: '信息认证',
        payChannel32: '周勤奖励',
        payChannel33: '幸运注单',
        payChannel34: '周年礼金',
        payChannel35: '棋牌奖励',
        payChannel36: '棋牌救援',
        payChannel37: '千倍百倍',
        payChannel38: '亿元回馈',

        interestRecord1: '小时',
        interestRecord2: '领回',
        interestRecord3: '提前领取',
        interestRecord4: '计息中',
        interestRecord5: '已到期',
        interestRecord6: '已领取'
    },
    activationRecord: {
        title: '活动记录',
        text1: '每条活动的数据将会有一定的时间延迟，仅供参考使用',
        text2: '活动名称：',
        text3: '请输入活动名称',
        text4: '活动时间：',
        text5: '活动名称',
        text6: '参与时间',
        text7: '操作',
        text8: '查看详情'
    },
    highRebate: {
        title: '全民返利',
        text1: '累计返利:',
        Vnum: '会员总数：',
        effectiveVnum: '有效会员：',
        text2: '元',
        text3: '满',
        getConditions2: '元，且有效会员≥',
        getConditions3: '人，即可领取',
        text5: '领取',
        text6: '会员',
        text7: '我的推广码',
        text8: '下载推广码',
        text9: '我的邀请码',
        text10: '复制邀请码',
        text11: '我的推广地址',
        text12: '复制地址',
        text13: '规则说明',
        text14: '邀请会员',
        text15: '总投注：',
        text16: '累计获得总返利：',
        text17: '注册时间：',
        text18: '时间筛选：',
        text19: '会员账号',
        text20: '注册时间',
        text21: '总有效投注(元)',
        text22: '返利金(元)',
        text23: '领取返利',
        text24: '元',
        text25: '流水要求：',
        text26: '倍',
        text27: '取消',
        text28: '立即领取',
        messageErr1: '未满足领取要求，最低领取金额',
        messageErr2: '元,有效会员人数≥',
        messageErr3: '人,领取上限',
        text30: '领取成功!'
    },
    interest: {
        title: '利息宝',
        text1: '存款',
        text2: '年利率：',
        text3: '开放区间：',
        text4: '查看利息宝记录>',
        text5: '存款总额：',
        text6: '元/可再存入',
        text7: '元',
        text8: '存款笔数：',
        text9: '笔/可再存入',
        text10: '笔',
        text11: '存款金额：',
        text12: '单笔最低额度：',
        text13: '元',
        text14: '预计最高利率',
        text15: '最高可获利息：',
        text16: '元',
        text17: '购买利率说明',
        text18: '存款',
        text19: '元',
        text20: '最高年利率',
        text21: '小时',
        text22: '年利率',
        text23: '立即存入',
        text24: '存款成功',
        text25: '恭喜你，完成存款操作！您可在 利息宝记录中查看投注详情以及 奖金信息！',
        text26: '知道了',
        text27: '全部',
        text28: '进行中',
        text29: '未开放',
        text30: '已结束',
        text31: '输入金额不满足最低额度！',
        text32: '输入金额不可大于可再存入金额！',
        text33: '单笔金额超出上限！',
        text34: '可再存入笔数不足！',
        text35: '存入金额不可为空！',
        text36: '未开放',
        text37: '存入提升收益',
        text38: '进行中',
        text39: '存入提升收益',
        text40: '结束申请',
        text41: '查看',
        text42: '结束计息',
        text43: ''
    },
    download: {
        text1: `${skin}APP下载`,
        text2: `${skin}电脑版下载`,
        text3: `${skin}客户端囊括了真人、老虎机、捕鱼、街机电玩、体育赛事、棋牌等热门种类，让您随时随地畅享游戏的精彩！`,
        text4: '安卓/IOS客户端',
        text5: '不再劫持，安全稳定，时时防护，任性畅玩！',
        text6: '支持 Windows 7及以上操作系统',
        text7: '电脑版下载',
        text8: 'PT电脑版下载',
        text9: '下载通道暂未开放！',
    },
    //warp页面（首页头部）
    warp: {
        chinese: '中文',
        pc: "电脑版",
        help: "新手帮助",
        memberRegister: '免费开户',
        hello: '你好',
        balance: '余额',
        money: '资金',
        memberDeposit: '会员存款',
        memberWithdraw: '会员提款',
        // transfer: "户内转账",
        message: "站内信",
        sign: "签到",
        logout: "退出",
        index: '首页',
        live: '真人视讯',
        egame: "电子游艺",
        sport: "体育电竞",
        chess: "棋牌游戏",
        lottery: "彩票游戏",
        fish: '捕鱼游戏',
        discount: "优惠活动",
        service: "在线客服",
        download: "下载",
        cooperation: "合作专区",
        warpBottom1: '合作机构',
        warpBottom2: `关于${skin}`,
        warpBottom3: "博彩责任",
        warpBottom4: "规则与声明",
        warpBottom5: "牌照展示",
        warpBottom6: "常见问题",
        warpBottom7: "VIP俱乐部",
        clearCache: "清除缓存",
        advice: '建议使用IE9+浏览器、谷歌浏览器、火狐浏览器，给您的体验会更好哦！',
        tbh: `${skin}`,
        right: '版权所有',
        selfHelp: '自助'
    },
    //basic页面
    base: {
        changePsw: '更换密码',
        safetyLevel: '账号安全等级',
        phoneBind: "手机绑定",
        emailBind: "邮箱绑定",
        moneyPsw: "资金密码",
        bankcardBind: "绑定银行卡",
        vipLevel: "会员VIP等级",
        commonUser: "普通用户",
        distance: '距离',
        short: "还差",
        yuan: '元',
        system: '系统将在',
        nextWeek: "下周一0点",
        clear: "自动清除本周投注并重新累积",
        open: "开通",
        lowLevel: '低级',
        middleLevel: '中等',
        highLevel: '高级',
        experience: '经验值',
        toppest: '当前已达到最高等级'
    },
    //account页面（个人资料）
    account: {
        title: "完善个人资料",
        account: "登录账号",
        realName: "真实姓名",
        realNameP: '请输入您常用银行卡真实姓名',
        nickname: '用户昵称',
        phone: '手机号码',
        qq: '联系 QQ',
        birthday: '会员生日',
        qqP: "请输入您的常用QQ",
        wechat: "联系微信",
        wechatP: "请输入您的常用微信",
        email: "会员邮箱",
        emailP: "请输入您的常用邮箱（注意：邮箱可以帮助您找回登录密码）",
        confirm: '确 定'
    },
    'help': {
        'titel1': `关于${skin}`,
        'titel2': `${skin}成立于2009年，持有菲律宾政府颁发的网络博彩运营执照，同时也是网络博彩委员会制定有合法博彩牌照的网络博彩网站，是正规合法对外营业的专业赌场。公司与亚游（Asia Gaming）,波音（BBIN）, PT（PlayTech），MG（MicroGaming）进行技术合作，共同打造高品质的游戏平台，具有绝对的合法性和公平性。为广大客户提供丰富多彩的博彩活动，并提供丰厚的优惠回馈。`,
        'titel3': '诚信经营',
        'titel4': '公司严格遵守菲律宾政府规定博彩守则，以“诚”为本。100%信誉保证游戏公平、公正。您的每笔存取款业务在经过审核后都将安全、快捷的完成',
        'titel5': '公平公正',
        'titel6': '真人娱乐中的荷官均接受严格的国际赌场专业训练与认证，所有赌局都依据荷官动作做出反应，而不是无趣的电脑几率预设结果。我们运用高科技的网络直播技术，带给您亲历赌场的刺激体验。电子游艺使用最公平的随机数产生机率，让您安心享受多元，炫丽的娱乐性游戏。',
        'titel7': '安全与隐私',
        'titel8': '为了客户的网络安全，公司成立网络安全维护中心，并获得GEOTRUST国际认证，确保网站公平公正。而在游戏投注中，我们采用128位SSL加密传输系统，MD5加密保护为游戏平台和客户信息提供进一步保护。我们承诺，将继续不遗余力地严格实行保密和隐私制度，确保个人资料的安全，并保证不将您的资料泄露给任意一方。',
        'titel9': '友善和专业的客户服务团队',
        'titel10': '我们亲切友善的客服专员训练有素，在帮助解决客户疑难的同时也能给与您最优越和最贴身的服务。我们也有提供线上聊天的功能，让客户们能即时联络我们。',
        'titel11': '常见问题',
        'titel12': `一．${skin}注册`,
        'titel13': `1.如何注册${skin}真钱账户？`,
        'titel14': `点击网页右上角“免费开户”按钮，根据弹出页面需求,填写真实有效的信息后，${skin}后台系统将自动生成账户。如在此过程中产生任何问题，请立即联系${skin}客服人员。`,
        'titel15': `2.如何登录${skin}游戏？`,
        'titel16': `您可以登录官方网址或通过客户端，登录${skin}的游戏页面。`,
        'titel17': '3.有没有试玩？',
        'titel18': '我们提供免费试玩账号，让您了解以及熟悉我们的游戏平台和游戏种类，如果对我们游戏平台满意的话可以存款进行真钱游戏。（备注：试玩彩金仅供试玩，不参与提款）',
        'titel19': `3.为何无法正常浏览${skin}网站`,
        'titel20': `${skin}网站在无法抗拒因素干扰时可能会导致您无法正常浏览网站，如遇此类情况请立即联系${skin}客服人员。`,
        'titel21': `4.${skin}客户游戏年龄限制`,
        'titel22': `${skin}真钱账户年龄最低限制为21岁，凡21岁以下，${skin}谢绝注册！`,
        'titel23': `二．${skin}账户`,
        'titel24': '1.如何更改注册信息',
        'titel25': `${skin}必须使用真实姓名注册，一旦注册成功，姓名和账号无法更改；银行卡信息和密码可以在【会员中心】自行更改，如在此过程中遇到任何问题，可以随时联系${skin}客服。`,
        'titel26': '2.忘记密码怎么办？',
        'titel27': `${skin}共有2个密码。一个是您进入网站或者游戏的登录密码，另外一个是提款时使用的安全密码。`,
        'titel28': 'A.登录密码忘记：点击网站右上角的“忘记密码”：',
        'titel29': '1.通过输入安全密码来重置登录密码',
        'titel30': '2.通过您注册资料绑定的邮箱重置登录密码；',
        'titel31': '3.通过您游戏账号绑定的手机来找回登录密码；',
        'titel32': 'B.安全密码忘记：',
        'titel33': '1.请先登录您的账号，进入【会员中心】>【安全管理】>【安全密码】，通过设置安全问题重置安全密码；',
        'titel34': '2.通过游戏账号绑定的手机重置安全问题，重设安全密码。',
        'titel35': '3.如何完成存款',
        'titel36': 'A．存款',
        'titel37': `自您成功注册账号之后，您就可以开始存款业务。目前为止${skin}接受：“扫码支付” “在线支付”，“微信支付”，“支付宝转账”，及“网银转账/ATM及柜台”等存款方式。请您根据实际情况，选择最合适的存款方式。`,
        'titel38': 'B．完成存款之后多久可以添加到账户中？',
        'titel39': `根据您选择的存款方式的不同，金额到帐时间也会有所不同，一般都是即时到帐。如遇问题请联系${skin}客服人员。`,
        'titel40': 'C．存款之后是否有投注要求？',
        'titel41': '在您完成存款之后，在您没有领取任何奖金的情况下，您只需要完成存款额一倍的投注额，即可申请提款。',
        'titel42': '4.如何完成提款',
        'titel43': 'A．提款',
        'titel44': '在您的账号完成所有投注要求之后，您可以在【财务中心】的【会员提款】填写资料后提交申请，相关部门会立刻为您处理；申请提款时，请务必填写真实银行信息。提款一般5分钟内可以到帐。',
        'titel45': 'B．提款为什么被拒绝？',
        'titel46': `提款业务被${skin}相关部门退回之后，请您立即联系${skin}客服咨询。`,
        'titel47': '5.如何户内转账？',
        'titel48': '登录账号以后，电脑网页版点击右上角“资金-户内转账”，手机网页版点击首页下方“转账”，选择相应的游戏厅，游戏时选择“转入游戏平台”，提款时选择“转入主账户”。',
        'titel49': `三．${skin}游戏`,
        'titel50': `1.${skin}提供多少款游戏？`,
        'titel51': `${skin}目前提供多平台高支付游戏，包含：`,
        'titel52': '2.进入游戏很慢怎么办？',
        'titel53': '如果您进入我们的网站或游戏过于缓慢，建议您清除下缓存！ IE和360浏览器的步骤为：',
        'titel54': '1.请您先退出我们的网站。',
        'titel55': '2.点击浏览器右上角“工具”选择“Internet选项”，再点击“删除”，勾选“Cookie和网站数据”并点击删除，等待删除完成后请再次尝试进入游戏！',
        'titel56': `关于3.游戏中视频无法显示怎么办？${skin}`,
        'titel57': '建议您可以清除您的FLASH 缓存，请您点击这个链接网址：',
        'titel58': '然后点击“删除所有WEB站点”。在弹窗中点击“确认”即可完成操作！',
        'titel59': '4.手机可以玩游戏吗？',
        'titel60': '目前网站支持安卓和苹果手机，您可以使用网页游戏或者下载客户端游戏。但是就算是在WIFI的环境下，目前手机处理器的运行能力还是有限，有时会出现画面卡顿的情况。所以建议还是用电脑运行游戏！',
        'titel61': '5.如何产生游戏结果并保证游戏的公平性？',
        'titel62': `${skin}所有游戏结果均由游戏供应商所产生，游戏结果真实有效，${skin}会对所有的游戏结果负责。真人娱乐中的荷官均接受严格的国际赌场专业训练与认证，所有赌局都依据荷官动作做出反应，而不是无趣的电脑几率预设结果。电子游艺使用最公平的随机数产生机率，让您安心享受多元，炫丽的娱乐性游戏。`,
        'titel63': '6.如何下注，撤销投注，查询游戏记录？',
        'titel64': `${skin}所有游戏下注均在游戏页面拥有醒目下注按钮，根据您的投注习惯下注即可。老虎机类游戏无法撤销投注，一经点击游戏自动开始，请妥善点击。真人现场类或体育竞技类游戏在投注未被接受之前，可以选择取消投注。所有游戏记录均可在游戏页面菜单中查询。如遇任何问题，请随时联系${skin}客服人员。`,
        'titel65': '7.为什么投注记录中的有效投注额和你们统计的不一致呢？',
        'titel66': 'AG平台和波音平台都是采用的美东时间（美国东部时间如：纽约、华盛顿时间）所以投注记录中的时间会和实际投注时间有差别。例如实际投注时间为当天晚上20:00则记录上显示的时间为当天早上8:00，有12个小时的时差。MG采用的格林威治时间，和北京时间有8个小时时差。',
        'titel67': '8.真人现场游戏是实时游戏吗？游戏页面是否作假？',
        'titel68': `${skin}真人现场游戏提供商为Playtech、AG、Microgaming、BBIN，其旗下所有真人现场游戏均为实时游戏。PT牌桌旁边电视中播放美国CNN电视台或者其他著名电视台全球同步的节目，此外您还可以随时与真人现场荷官聊天；AG您可以拨打桌面的菲律宾电话进行实时通话。`,
        'titel69': '9.如果游戏突然中断遇突发状况我该怎么办？',
        'titel70': `${skin}游戏经过不断完善已经在同行业中属于极为稳定的游戏环境。但是由于国际网络，客户所在国家地区等诸多不可控制因素干扰，游戏有可能会突然中断。如遇到此类问题，请勿惊慌焦躁，立即联系${skin}客服人员协助处理。在此${skin}郑重承诺，凡是由于${skin}方面造成的游戏损失，${skin}一定会为此负责及赔偿！。`,
        'titel71': `四．${skin}投注及奖金要求`,
        'titel72': `1.${skin}如何获得奖金`,
        'titel73': `${skin}提供了许多优惠奖金获取机会，部分奖金是您无需申请，自动添加至您的账户中，另外一些奖金则需要您申请，通过之后自动为您添加。`,
        'titel74': '2.可以取消奖金吗？',
        'titel75': '在您账户获得奖金之后，是无法取消的。',
        'titel76': '3.没有完成投注要求是否可以提款？',
        'titel77': `${skin}所有真钱账户在没有完成相应奖金投注要求之前，谢绝提款业务。如果您的账户余额低于5元人民币时，之前的所有投注要求将会自动清零。`,
        'titel78': '联系我们',
        'titel79': `${skin}客服部`,
        'titel80': `${skin}客服部是指定对客服务部门，客服部工作性质为24小时线上服务，其服务沟通渠道包含“在线客服”“热线”“QQ客服”及“投诉与建议”。如果您在${skin}游戏中遇到任何问题，您可以通过以下方式联系客服人员寻求帮助，客服部专业24小时客服人员竭诚为您服务！`,
        'titel81': '温馨提示：',
        'titel82': `以下联系方式为${skin}指定服务通道，如遇到冒充、伪造或未经证实的沟通案例，请勿相信其任何内容，并且请您及时联系本公司客服人员核实或反映情况！在此声明，如客户在虚假服务中受到任何损失，恕本公司概不负责！感谢您的支持帮助与理解！`,
        'titel83': '在线聊天包含:',
        'titel84': '1. 官方在线客服。',
        'titel85': '2. 营销QQ客服：1579010。',
        'titel86': '2. 官方热线：0063-9695-600000',
        'titel87': '3. 建议及投诉邮箱：cs@sanos8888.com',
        'titel88': '规则与声明',
        'titel89': '本公司是合法互联网交易机构，现提醒有意参与本公司所有游戏之客户，应注意其国家或居住地区的相关法律规定，如有疑问，应就相关问题寻求当地法律意见。 本条款涵盖您与本公司，在本网站进行博彩行为时的所有协议。',
        'titel90': '1、法定要求',
        'titel91': '根据您所居住国的法律，您必需达到法定年龄，您才可使用本网站。',
        'titel92': '如果您尚未年满21岁，在任何情况下您都不可使用本网站。',
        'titel93': '部份地区或国家法律尚未明确在线博彩的合法性问题，甚至某些地区或国家已明确规范在线博彩为非法行为。我们无意邀请任何人在这些地区或国家非法使用本网站。本网站的存在并不表示我们推广在线博彩于任何赌博非法的地区或国家。您必需确定在您所居住的地区或国家使用在线博彩是否合法，并负完全的责任。',
        'titel94': '2、帐户规定',
        'titel95': '客户只能拥有一个账号，如发现客户拥有多个账号，本公司有权冻结客户的账号以及取消该账号内所有胜出的投注。本公司有权保留取消任何因素导致账号结余不正确的金额。此外如发现账号持有人与亲属共同使用多个不同账号，本公司有权限制客户每人各保留最多一个账号。若上述情形已构成欺诈、危害或侵犯本公司及其它用户权利或利益时，本公司有权要求该用户赔偿并没收用户帐户中所存之余额，终止或注销用户继续使用本系统的权利',
        'titel96': '3、交易结算',
        'titel97': '用户有责任及义务在每次游戏交易之前或之后及离开游戏前，检查自己的账户余额。当用户怀疑余额有错误时，必需在进行下一回合的游戏（游戏开始到结账画面出现视为一个回合）前，向本网站在线客服人员或本公司客服部人员提出申诉。如果您不这么做，本公司将视为您放弃提出申诉的权利，并接受目前的余额数据为正确。',
        'titel98': '直接与本公司交易结算的用户，银行帐户名称须与会员登记和申请过程中所使用的姓名一致。若用户使用信用卡或借记卡时，持卡人姓名亦须与会员登记和申请过程中所使用的姓名一致。若发生银行账户名称或持卡人姓名和账户登记(会员注册)时所使用的姓名不一致时，本公司有权拒绝相关交易的结算',
        'titel99': '用直接与本公司交易结算的用户，本公司会依据用户所提供的交易方式信息，将博彩所得存入您的用户帐户中。任何款项或所得在存入账户的过程中，若因为用户所提供的信息不足或信息错误而发生交易错误的情形时，本公司不负任何形式的责任。用户一旦发现帐户内款项有误时，有责任立即通知我们。',
        'titel100': '本公司因用户的结算交易而蒙受的银行费用，包括手续费、电邮费等，本公司有权从用户的帐户余额中扣除和抵扣上述费用。',
        'name1': 'JACKPOT 中奖后将根据具体中奖金额扣取一定的奖池管理费，具体以游戏平台公司的收取金额作为依据。',
        'name2': '4、本公司之权利与义务',
        'name3': '本公司会采取各种措施保护玩家的账户安全。',
        'name4': '本公司绝不会以任何人为的手段，影响游戏的公正性。',
        'name5': '本公司对非法使用玩家账户的行为不负任何责任。',
        'name6': '本公司保留修改所有制度及规则条款的权利。',
        'name7': `本公司若发现玩家在游戏中，有作弊、攻击或破坏本系统正常操作以及使用明确表示或暗示的方式以与事实不符、莫须有之说针对「${skin}娱乐城」诋毁、漫骂、恐吓、毁谤的行为，经公司劝阻不止，本公司保留拒绝/禁止和吊销玩家继续使用本系统的所有权利 ，"并将依菲律宾共和国法律进行追诉"。`,
        'name8': '本公司对于您个人的数据及在系统中进行的记录，皆有「备份数据」。但若不幸发生不可抗拒之因素（如天灾、恐怖活动、战争、暴动…）导致上述数据遗失时，本公司会尽全力恢复所有的历史数据，所恢复的数据也将视为公正。',
        'name9': '5、促销和优惠',
        'name10': '所有促销、优惠和特别活动均须遵守本条款及本公司针对具体优惠活动所不时制定的规则与条款。本公司保留在任何时候中止、取消或修改该等促销、奖励和特别活动之相关规定及条款的权利。',
        'name11': '若本公司认定有人滥用或企图滥用某项促销或奖励活动，或可能因该等滥用行为而获利时，本公司有权自主决定以其认为合适的方式阻止、拒绝、中止或撤销任何用户参加有关的促销、奖励和特别活动。',
        'name12': '6、条款修改政策',
        'name13': '本公司保留不时修订、更新和修改本条款和游戏规则的绝对权力。任何修订、更新和修改将在官网上公布。经修订、更新或修改的本条款和游戏规则，在公布时即生效。用户在上述修订、更新和修改公布后，继续使用本网站或游戏时，则视为用户同意并接受本公司的修订、更新和修改。',
        'name14': '我们建议您定期阅读本网站之规则与条款及游戏规则。',
        'name15': '上述修订、更新和修改，本公司可自行决定是否通知用户。本公司并无任何义务向用户通知上述之修订、更新和修改。',
        'name16': '会员存款',
        'name17': '绿色通道',
        'name18': '支付宝转银行卡',
        'name19': '银联扫码',
        'name20': '博彩责任',
        'name21': '牌照展示',
        'name22': '防劫持帮助',
        'name23': '存款演示',
        'name233': '取款演示',
        'name24': '一. 防劫持说明',
        'name25': '如果您使用移动设备访问我们网站的地址，打开网页后跳转至其他的网站。应该如何处理？',
        'name26': '这是属于DNS劫持情况，DNS简称域名劫持，是属于被网络黑客利用了服务器的漏洞，更改了您的域名原IP，然后跳转至其他假网站。可能引起您失误操作，甚至会危害到您的账户和财产安全。',
        'name27': '二. 操作说明',
        'name28': '安卓客户端',
        'name29': 'IOS客户端',
        'name30': `${skin}是在菲律宾拥有合法经营权的机构, 其确保${skin}运营的公正性和合法性，从而保障了客户与${skin}之间的公平、公正及资金安全！PT游戏是由PT TransPacific在PAGCOR的授权下部署。`,
        'name31': 'CEZA认证',
        'name32': 'PAGCOR认证',
        'name33': '执照号码OGL16-0014',
        'name34': '未满博彩年龄',
        'name35': '本公司是合法互联网交易机构，现提醒有意参与本公司所有游戏之客户，应注意其国家或居住地区的相关法律规定，如有疑问，应就相关问题寻求当地法律意见。 本条款涵盖您与本公司，在本网站进行博彩行为时的所有协议。',
        'name36': `${skin}娱乐城积极推行负责任博彩，并极力拒绝未成年玩家使用我们的软体进行网上娱乐。同时，我们更通过专业人员及各种有效方法，以防止问题博彩的发生。 一旦发现使用该本网站的客户未满21岁，我们将会没收所有赢取的彩金并保留立即终止客户的投注户口操作的权利。`,
        'name37': '本服务不提供给未满21岁之任何人士。所有使用本服务的人士所提供的数据显示其年龄已满21岁。如本公司认知未满21岁之人士尝试或已提供数据给予本网站，本公司将不接受其数据并采取清除其数据的动作。',
        'name38': '如您的电脑被未满21岁的人士使用， 我们建议您设定电脑资料保密以防止帐户号码/用户名称被盗用。',
        'name39': '博彩行为检视',
        'name40': '博彩只是一种娱乐，大部分玩家视博彩为消闲娱乐。然而小部分玩家无法自制，沉迷于赌博，往往对自己及社会均造成伤害。以下是为玩家准备的博彩问题测试，阁下可以测试是否面临以下的问题。',
        'name400': '1.您是否因为博彩而不上班或不上学？',
        'name41': '2.您博彩是否为了逃避烦闷或不愉快的生活？',
        'name42': '3.当您博彩花光钱时，您是否感到失望甚至绝望，并且希望马上能再进行赌博？',
        'name43': '4.您会否博彩到最后一分钱才罢休？',
        'name44': '5.您有否曾经用谎言掩饰您花在博彩上的时间和金钱？',
        'name45': '6.您博彩是不是因为争执，沮丧或失望？',
        'name46': '7.您有没有因为博彩而感到失落甚至轻生？',
        'name47': '8.您是否对您的家人，朋友或爱好失去了兴趣？',
        'name48': '9.您输了之后，是否马上想把输的钱赢回来？',
        'name49': '在这些问题中您回答的‘是’越多，您就越接近具备严重博彩问题。',
        'name50': '为了协助您判定所设定的限制是否合适于您，请仔细考虑：',
        'name51': '1.在还未开始博彩之前制定一个可以接受的输赢额度',
        'name52': '2.留意您花费多长时间在博彩游戏',
        'name53': '3.按您实际情况制定一个您每天、每周或每月的投注额度',
        'name54': '责任感和正直诚信',
        'name55': `${skin}娱乐城致力于提高服务水准，并承诺向客户履行最大程度上的责任，包括诚信、透明度、合法性等各方面。如客户遇上任何有关责任博彩的问题，可24小时向我们的客户服务部联络。我们承诺会于一年365日，不间断地为用户提供技术支援及相关问题解答服务。`,
    },
    'helpamjs': {
        'titel0': `关于${skin}`,
        'titel1': `${skin}注册于菲律宾马尼拉，持有菲律宾政府卡格扬经济特区 First Cagayan leisure and Resort Corporation颁发的体育博彩与线上赌场执照，接受菲律宾政府和卡格扬经济特区CEZA授权和监管，我们一切博彩营业行为皆遵从菲律宾政府博彩条约。在竞争日益激烈的网络博彩市场中，我们不断地求新求变，寻找最新的创意，秉持最好的服务。向客户提供高品质的服务、先进的产品、丰富的娱乐体验，是我们${skin}永恒的宗旨。`,
        'titel2': '我们思您所想，提供高标准全方位的个人隐私保密措施以及高强度的资金安全体系。玩家网上支付和所有银行交易将由国际金融机构通过高标准的安全和机密的网络端口（SSL 128 bit encryption Standard）中进行。进入玩家帐户数据也必须有玩家唯一的登录ID和密码，确保客户的资金安全有保障。同时也采用最先进的加密措施来保证玩家的游戏安全，7×24小时的后台检测和监控，确保我们可以提供一个完全公正和安全的网络游戏空间。客户在本平台的所有活动均严格保密，我们绝不会向第三方（包括相关单位）透露客户数据。',
        'titel3': '我们向您承诺：',
        'titel4': '以诚信为本',
        'titel5': '作为国际专业的网上博彩游戏运营商，我们承诺，为每一位客户提供最安全、最公平的博彩游戏，以及全方位的服务。',
        'titel6': '提供最多样化与最真实的游戏',
        'titel7': '我们的真人视讯里面的荷官都是经国际赌场专业训练的，专业、高效、严谨！每一局派牌均由荷官现场实时派发，而不是预设的电脑机率结果。通过高科技的网路直播技术，带给您身临赌场现场的刺激经验!',
        'titel8': '我们的运动博彩拥有顶级的盘房操盘，投入大量的人力以及资源，以求将完整的赛事，丰富的玩法带给热爱体育的玩家。',
        'titel9': '各式彩票游戏，是依官方赛果产生的游戏结果，让玩家在活泼的投注界面，享受最真实的娱乐。',
        'titel10': '我们的电子游戏是与国际顶尖的电子游艺开发团队共同研发，采用最先进的动漫视觉效果，使用最公平的随机数产生机率，让您安心享受多元、刺激，观感丰富的电子游艺。',
        'titel11': '本公司所有的游戏皆有共同的优点: 无须下载、介面操作简易、功能齐全、画面精致、游戏秉持公平、公正、公开!',
        'titel12': '提供优质的客户服务',
        'titel13': '我们有以最高标准选拔、最严格训练的客服团队，向您提供365天×24小时实时在线的客户服务。每位玩家的咨询，都将以专业、亲切的态度解答，在帮您解决问题的同时带给您宾至如归的体验!提供多渠道的与客户的互动交流，了解客户的需求，随时关注客户的意见及建议；举办更多的优惠及促销活动，给客户提供更多的回馈及惊喜。',
        'titel14': '高效安全的存取款',
        'titel15': '我们提供各种安全简便的存款及取款选择给我们的会员。我们一直坚持“了解我们的会员（KYC）”和 反洗钱(AML)的原则，并与第三方的财务管理当局合作以确保最大范围的遵从相关的法律法规。',
        'titel16': '我们对我们所建立的公司深感自豪，并希望所有的用户能够在一个安全愉快的环境下享受我们精心设计的产品和服务并能够从中获利。 我们提供最迅捷最安全的取款方式，会员365天×24小时均可申请取款。',
        'titel17': '让您成为大赢家',
        'titel18': '将不间断的推出各式各样有利新老会员的优惠，天天送惊喜、周周有回馈，月月大放送，让您成为大赢家。',
        'titel19': '积极参与慈善公益',
        'titel20': '我们在尽心为每一位会员服务的同时，也肩负着对社会、对慈善公益的责任。取之于社会，用之于社会也是我们一直秉承的宗旨之一。我们积极参加各种捐款活动，也将永不磨灭的针对社会的需要作出更多的产生。',
        'titel21': '本公司提倡有节制的赌博。我们建议阁下遵守以下一些基本规则：',
        'titel22': '• 禁止未满18岁的人士参与赌博游戏。在加入游戏之前，请您确定您已年满18周岁。',
        'titel23': '• 自定博彩预算，并按预算下注。',
    },
    //棋牌奖励
    Reward: {
        title: '棋牌奖励金',
        table1: '日期',
        table2: '完成总局数',
        table3: '有效投注额',
        table4: '奖励金',
        receive: '领取',
        receive1: '已领取',
        receive2: '未达成领取条件',
        footer1: '温馨提示：',
        footer2: '1. 根据会员每日在开元棋牌、761棋牌、三国棋牌、大富翁棋牌平台所完成的游戏总局数， 且当天在上述棋牌平台的总有效投注额≥1000元，即会返送相对应的奖励金',
        footer3: '2. 每日16点前，统计昨日北京时间00点--23点59分59秒产生的总局数。',
        footer4: '3. 每日活动的奖励金不可累积，如用户在某一天未领取奖励金，则视为自动放弃该奖励将清零重新统计。',
        footer5: '4. 活动礼金不限游戏，只需1倍流水即可提款。',
        footer6: '5. 温馨提示： ',
        footer7: '点击此处查看',
        footer8: '棋牌奖励金优惠详情',
        message1: '领取成功！',
        message2: '奖励已领取！',
        text1: '月',
        text2: '日',
    },
    //棋牌救援
    Rescue: {
        title: '棋牌救援金',
        table1: '日期',
        table2: '负盈利',
        table3: '奖励金',
        receive: '领取',
        receive1: '已领取',
        receive2: '未达成领取条件',
        footer1: '温馨提示：',
        footer2: '1. 活动期间，根据会员每日在开元/761/三国/大富翁棋牌的负盈利，即可获得对应的救援金！',
        footer3: '2. 活动时间：2018-08-01起，长期有效',
        footer4: '3. 每日中午12点前，统计昨日北京时间00点--23点59分59秒产生的负盈利。',
        footer5: '4. 每日活动的救援金不可累积，如用户在某一天未领取，则视为自动放弃该救援金，第二日将清零重新统计。',
        footer6: '5. 温馨提示： ',
        footer7: '点击此处查看',
        footer8: '棋牌救援金优惠详情',
        message1: '领取成功！',
        message2: '奖励已领取！',
        text1: '月',
        text2: '日',
    },
    //自助优惠---周年礼金 + 千倍万倍页面
    Anniversary: {
        tip1: '温馨提示：如您在周年礼金领取日开始之前累积存款未达到 1 元，将无法获得此优惠！',
        tip2: '发放时间：首次存款日期开始，每满一整年后隔日凌晨1:30分开始发放！',
        tip3: '未满足参与条件，没有首存款',
        tip4: '领取',
        tip5: '已领取',
        tip6: '【查看优惠详情】',
        tip7: '恭喜您成功领取',
        tip31: '奖励，请注意账户余额变动',
        tip8: '温馨提示：每天（00:00至当天23:59:59）只能领取一次千百倍奖金！（提交错误信息超过5次，取消当日申请资格）',
        tip9: '千倍万倍',
        tip10: '游戏平台',
        tip11: '游戏时间',
        tip12: '投注额',
        tip13: '中奖倍数',
        tip14: '获得奖金',
        tip15: '备注',
        tip16: '操作',
        tip17: '申请奖励',
        tip19: '暂无中奖纪录',
        tip20: '温馨提示',
        tip21: '如遇网络因素不显示当前符合的注单，请稍后刷新网络后重试或点击下面的自助提交',
        tip22: '*CQ9、DT、AE、TTG 等平台，请点击！',
        tip23: '自助提交投诉建议。',
        tip24: '1. 当游戏的中奖牌局总派彩为投入额',
        name2: '百倍',
        name3: '以上时派发的奖金，满足条件的会员可自助申领。',
        tip25: '2. 活动时间：2019年3月14日至2020年6月1日(00:00:00-23:45:00)。',
        tip26: '3. 每位用户每天只可领取',
        name: '次千百倍奖金，如当日未领取，则视为自动放弃该奖励，第二日将清零重新统计。',
        tip27: '（注意：不包括平台中的捕鱼游戏、现场庄家、视频扑克、街机游戏、牌桌游戏和刮刮乐等游戏。)',
        tip28: '4. 活动礼金不限游戏，只需12倍流水即可提款。',
        tip29: '点击此处查看',
        tip30: '是否确认申请该注单奖励',
        tip33: '提示',
        tip32: '确定',
        tip34: '取消',
        tip35: '未满足领取条件',
        tip36: '没有首付款',
        tip37: '周年礼金',
        tip38: '点击关闭即返回自助大厅',
        tip39: '第一次存款日期',
        tip40: '当前VIP等级',
        tip41: '预发放周年礼金',
        tip42: '这里',
        tip43: '优惠详情。',
        tip44: '距满年时间还有',
        tip45: '温馨提示',
        tip46: '没有首存款',
        tip47: '确定',
        tip48: '已领取',
    },
    //自助优惠-周勤奖励
    weekAward: {
        title: "周勤奖励",
        topTips: "温馨提示：每天14点统计更新上一天的有效投注额！",
        thisWeek: '本周周勤',
        lastWeek: '上周周勤统计',
        thisTurnDayCount: '本周已出勤',
        day: '天',
        thisTotalEffeBetsAmount: '累计有效投注额',
        yuan: '元',
        lookLastRecords: "【查看上周记录】",
        lastTurnDayCount: '上周累计出勤天数',
        lastTotalEffeBetsAmount: '上周累积的有效投注额',
        weekGift: '周勤礼金',
        seeGift: '奖励一览',
        keepOnFighting1: '上周未达到发放条件',
        keepOnFighting2: '本周请继续努力',
        keepOnFighting3: "您上周已达到发放条件",
        keepOnFighting4: "请注意余额变动",
        botTips: "温馨提示：",
        botTip1: `1. 活动介绍：${skin}会员只要在一周内，累计四天有进行游戏投注，且这四天之中，每日有效投注额不小于300元，周有效投注额不小于5000元，即可获得相应的周勤奖金！`,
        botTip21: "2. 发放时间：",
        botTip22: "每周二14:00",
        botTip23: '之前，系统会完成',
        botTip24: '上一周',
        botTip25: '投注情况的统计，达到条件的会员会在',
        botTip26: "18：00之前",
        botTip27: '由系统发放 。',
        botTip3: "3. 【首存优惠】和【周勤礼金】优惠不能在同一周且不能同时享受。",
        botTip4: "4. 需要八倍流水才可提款。",
        botTip5: `5. 该活动若存在文字理解的差异，则最终解释权归【${skin}】所有，且【${skin}】有权更改、结束、缩短、延长该活动。`,
        weekGiftTableLabel1: "周出勤(单日投注>300)",
        weekGiftTabelLabel2: '周有效投注额（元）',
        weekGiftTabelLabel3: '周勤礼金（元）',
        weekGiftCalcu: '周勤奖励礼金计算',
        lastWeekAwardCalcu: '上周周勤记录',
        minSignDay: '最低',
        through: "至",
        unget: "领取奖励",
        geted: "已领取"
    },
    //幸运注单
    luckyNote: {
        title: '幸运注单',
        topTips1: '温馨提示：每天（00:00至当天23:59:59）只能领取',
        topTips2: '次幸运注单！每个注单号只能申请一次！（提交错误信息超过5次，取消当日申请资格）',
        platForm: '电游平台',
        gameTime: '游戏时间',
        betMoney: '下注金额',
        luckyNoteNum: '幸运注单号',
        actGift: '活动礼金',
        operation: '操作',
        apply: '申请',
        applyed: "已申请",
        middleTips: '如遇网络因素不显示当前符合的注单，请稍后刷新网络后重试或点击下面的自助提交',
        text1: "*幸运注单自动查询",
        text2: "不支持DT平台",
        text3: "，如有需要请在",
        text4: "这里",
        text5: '自助提交',
        applyRecords: "今日申请记录",
        clickThis: "点击此处查看",
        luckyNotedetail: '幸运投注优惠详情',
        applyTime: '申请时间',
        applyPlatForm: '申请平台',
        betNum: '投注单号',
        awardMoney: '洗码奖励金额',
        effBetMoney: '洗码有效投注额',
        remarks: '备注',
        isConfirmApply: "是否确认申请该注单奖励？",
        confirm: '确认',
        cancel: '取消',
        applySuccess1: '恭喜您成功领取',
        applySuccess2: "奖励，请注意账户余额变动！",
        applyFail: '未满足领取条件',
        emptyText1: "--暂无记录--",
        emptyText2: "暂无数据",

    },
    //信息认证
    credentials: {
        title: '信息认证',
        name: '信息认证红利',
        bank1: '银行卡验证',
        pawess: '安全密码验证',
        text1: '历史累计存款',
        text2: '元',
        text3: '认证红利（元）',
        text4: '用户需完成上述所有认证并审核通过后，才能够领取此红利',
        text5: '[完善认证]',
        text6: '未满足领取条件',
        text7: '提示：',
        text8: '温馨提示：',
        text9: '1. 用户必须完成通过所有认证以及历史累计存款不小于',
        text91: '元后，才达到申领条件！',
        text10: '2. 每个账户只允许申领一次信息认证红利。',
        text11: '3. 如您对此还有疑问，可点击查看',
        text12: '认证红利',
        text13: '规则。',
        failed: '未达到领取要求',
        received: '领取',
        receivedt: '已领取',
        'realName': "姓名",
        'email': "绑定邮箱",
        'phone': "绑定手机号",
        'qq': "绑定QQ号",
        'safePassword': "安全密码验证",
        'bank': "银行卡绑定",
        'digitalCurrency': "绑定数字货币",
        'origin': "绑定钱包",
        'deposit': "累计存款",

    },
    //亿元回馈
    feedback: {
        title: '亿元回馈',
        state: '开始日期',
        storp: '结束日期',
        table1: '出款流水',
        table2: '盈亏预算',
        table3: '奖励金额',
        table4: '操作',
        tips: '温馨提示：',
        text1: '如遇网络因素不显示当前符合的注单，请稍后刷新网络后重试或点击下面的自助提交',
        text2: '请点击 ',
        text3: '这里',
        text4: '自助提交投诉建议。',
        text5: `1. 活动对象：所有${skin}普通VIP及以上的会员。`,
        text6: '2. 所获礼金1倍流水出款。',
        text7: '3. 领取时间：每月1日、11日、21日，即可领取。',
        text8: `4. 此活动可以${skin}所有优惠同时共享。`,
        text9: ` 5. 所有客户只能拥有一个账号：同一个IP、同一个存/提款卡、同一个手机号码、同一个邮箱都视为同一个客户， 如果发现同一个拥有两个或以上的账户，重复的账户将会被冻结，【${skin}】保留索回重复账户的奖励及盈利的权利。`,
        text10: '6. 参与该优惠，即表示您同意《优惠规则与条款》。',
        text11: '点击此处查看',
        text12: '优惠详情。',

    },

};
export default zh;